import {Injectable} from '@angular/core';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {catchError} from 'rxjs/operators';
import {EmailRecipient} from '@docma-mm-core/email-distributor/email-recipient';
import {map} from 'rxjs';

@Injectable()
export class EmailDistributorApiService extends BasedataService {

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  getGlobalDistributors() {
    const param = new URLSearchParams({ onlyActive: 'true' });
    const endpoint = super.getFullUrl('/configuration/email/sending/distributors/recipients?' + param.toString());

    return this.http.get<EmailRecipient[]>(endpoint, { headers: this.getHeaders() })
      .pipe(map(res => {
        return res.map(er => {
          er.Type = 'global';
          return er;
        });
      }), catchError(e  => this.handleError(e)));
  }

  getProjectDistributors(projectId: number) {
    const param = new URLSearchParams({ onlyActive: 'true' });
    const endpoint = super.getFullUrl(`/projects/${projectId}/configuration/email/sending/distributors/recipients?` + param.toString());

    return this.http.get<EmailRecipient[]>(endpoint, { headers: this.getHeaders() })
      .pipe(map(res => {
        return res.map(er => {
          er.Type = 'project';
          return er;
        });
      }), catchError(e  => this.handleError(e)));
  }
}
